import React from 'react';
import api from '../services/api';
import { toast } from '../utils/toastBus';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    try {
      if (process.env.NODE_ENV === 'production') {
        void api.trackClientError({
          name: error?.name || 'Error',
          message: error?.message || 'Unknown rendering error',
          stack: typeof error?.stack === 'string' ? error.stack : undefined,
          componentStack: typeof info?.componentStack === 'string' ? info.componentStack : undefined,
          path: typeof window !== 'undefined' ? window.location?.pathname : undefined,
          href: typeof window !== 'undefined' ? window.location?.href : undefined,
        });
      }
    } catch {}
    try {
      toast({ type: 'error', message: 'A rendering error occurred' });
    } catch {}
  }
  render() {
    if (this.state.hasError) {
      return React.createElement(
        'div',
        {
          style: {
            color: '#f7f5f2',
            padding: 32,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
          },
        },
        React.createElement('div', { style: { fontSize: 15, color: '#f87171' } }, 'Something went wrong.'),
        React.createElement(
          'div',
          { style: { display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' } },
          React.createElement(
            'button',
            {
              onClick: () => window.location.reload(),
              style: {
                padding: '8px 16px',
                borderRadius: 8,
                border: 'none',
                background: 'var(--loud-orange, #ff5a1f)',
                color: '#0a0810',
                fontWeight: 700,
                cursor: 'pointer',
              },
            },
            'Reload page'
          ),
          React.createElement(
            'a',
            {
              href: '/',
              style: {
                padding: '8px 16px',
                borderRadius: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#f7f5f2',
                textDecoration: 'none',
                fontWeight: 700,
              },
            },
            'Go home'
          )
        )
      );
    }
    return this.props.children;
  }
}
